<template>
  <div class="flex flex-right">
    <template v-if="$acl.check('onlyTenders')">
      <ExportToExcel
        v-if="tender.tenderStatus.id !== 1"
        :disabled="loadingParticipantToExcel"
        :loading="loadingParticipantToExcel"
        :open.sync="modalExportToExcel"
        :small-btn="true"
        @ok="exportParticipantToExcel">
        <div
          slot="dialogContent">
          <sRadioGroup
            v-model="inviteType"
            data-qa="radio-participant-to-excel">
            <sRadio
              data-qa="radio-participant-to-excel-all"
              :label="0">
              {{ `${$t('Purchasing.All')} ${$t('Tenders.InvitedParticipants')}` }}
            </sRadio>
            <sRadio
              data-qa="radio-participant-to-excel-all"
              :label="1">
              {{ $t('Tenders.ManuallyInvitedParticipants') }}
            </sRadio>
            <sRadio
              data-qa="radio-participant-to-excel-all"
              :label="2">
              {{ $t('Tenders.SubscribedToCategory') }}
            </sRadio>
          </sRadioGroup>
        </div>
      </ExportToExcel>
      <ResendInvitations
        v-if="tender_status == 4 && !members.some(el => el.active)"
        :tender="tender"/>
      <Youcontrol
        v-if="tender_status === 4 || tender_status == 7"
        class="mr-2"
        :hide-limit-hint="tender_status == 7"
        small
        @result="inviteMembers"/>
      <InviteNewParticipation
        v-if=" can_invite"
        :apply-func="addMember"
        :invited.sync="all_members"
        one_more
        :to_action="tender_status == 7"/>
      <CategoryDropdownTree
        v-if="can_add_cats"
        :apply="apply"
        item_key="code"
        :label="$t('Tenders.Category')"
        :model.sync="categories"
        multiple
        :used="used">
        <template #activator="{on , items, open }">
          <div v-on="items && items.length == 5 && tender_status != 1 ? on : ''">
            <TooltipedBtn
              :color="items && items.length == 5 && tender_status != 1 ? 'grey' : 'var(--black-color)'"
              :disabled="items && items.length == 5 && tender_status != 1"
              icon="plus"
              :small-btn="true"
              :text="$t('Tenders.AddSdditionalCategories')"
              :texted="$vuetify.breakpoint.xlAndUp && $t('Common.Add')"
              @click="open"/>
          </div>
        </template>
        <template #used_text="{ item }">
          {{ item.classificationCode !== tender.category.code ? $t('Tenders.SelectedInAdditionalCategory') : $t('Tenders.SelectedCategory') }}
        </template>
      </CategoryDropdownTree>
    </template>
    <SearchInput
      class="ml-2"
      debounce
      :search.sync="search"
      small
      @input="$emit('setMembersGroups')"/>
  </div>
</template>
<script>
import SearchInput from 'components/common/inputs/SearchInput.vue'
import Youcontrol from  'components/tenders/dialogs/Youcontrol.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import ExportToExcel from 'components/common/dialogs/ExportToExcel.vue'
import ResendInvitations from 'components/tenders/dialogs/ResendInvitations.vue'
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'
import InviteNewParticipation from 'components/tenders/dialogs/InviteNewParticipation.vue'

import axios from 'axios'
import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import { tenderMixin } from 'mixins'
import emailRejectionsMixin from 'mixins/emailRejectionsMixin.js'
import { withoutRejected } from '@/helpers/emailRejections.js'
import { isUnknownEmailsLimitRejection } from '@/helpers/unknownEmailsLimit.js'

export default {
  name: 'membersBtns',
  mixins: [ tenderMixin, emailRejectionsMixin ],
  data() {
    return {
      modalExportToExcel: false,
      loadingParticipantToExcel: false,
      inviteType: 0,
      categories: []
    }
  },
  props: {
    tender: Object,
    can_invite: Boolean,
    members: Array,
    bidding_type: Object,
    memberSearch: String
  },
  created() {
    this.categories = this.tender.additionalCategories.map(el => ({
      id: el.code,
      classificationCode: el.code,
      title: el.title
    }))
  },
  computed: {
    can_add_cats() {
      return (this.tender_status == 1  || this.tender_status == 4)
        && this.bidding_type.isPublic
    },
    tender_status() {
      return this.tender?.tenderStatus?.id
    },
    used() {
      let codes = [this.tender.category.code]
      if ( this.tender_status != 1) {
        codes = codes.concat(this.tender.additionalCategories.map(el => el.code) )
      }
      return codes
    },
    search: {
      get() {
        return this.memberSearch
      },
      set(value) {
        this.$emit('update:memberSearch', value)
      }
    },
    all_members: {
      get() {
        return this.members || []
      },
      set(value) {
        this.$emit('update:members', value)
      }
    },
  },
  methods: {
    inviteMembers(emails) {
      if (!emails?.length) {
        return
      }
      const invited = this.all_members.map(i => i.email)

      const parseEmails = emails
        .map(i => ({
          email: i,
          manualAdded: true,
          organizationId: 0,
          organizationTitle: '',
          organizationUsreou: '',
          selected: true,
          uniqId: (Math.random() + 1).toString(36).substring(7),
        })
        )
      this.addMember(
        this.$_checkRuEmailDomen(parseEmails)
          .filter(i => !i.blockDomen && !invited.find(ie => ie  === i.email))
      )
    },
    async exportParticipantToExcel() {
      this.loadingParticipantToExcel = true
      const uri = `${window.config.GrapgQlUrl}/files/generateReport/participants?tenderId=${this.tender.tenderId}&inviteType=${this.inviteType}`

      axios.post(uri, null,
        {
          headers: await files_api.getHeaders('application/json'),
          responseType: 'blob'
        }
      ).then((res) => {
        var blobUrl = URL.createObjectURL(res.data)
        let link = document.createElement('a')
        document.body.appendChild(link )
        link.style = 'display: none'
        link.href = blobUrl
        link.download = this.$t('Tenders.InvitedParticipants')
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
        }, 0)
      })
        .finally(() => {
          this.loadingParticipantToExcel = false
        })
      this.modalExportToExcel = false
    },
    async apply() {
      if ( !this.$_.difference(this.categories.map(el => el.id), this.tender.additionalCategories.map(el => el.code))?.length ) {
        return
      }
      let res
      if ( this.tender_status == 1 ) {
        res = await api.addAdditionalCategoriesToTender(this.categories?.map(el => el.classificationCode), this.tender.tenderId )
      } else {
        res = await api.addAdditionalCategoriesToTenderingStage({
          tenderId: this.tender.tenderId,
          categories: this.categories.map(el => el.classificationCode)
        })
      }
      if (res ) {
        // eslint-disable-next-line vue/no-mutating-props
        this.tender.additionalCategories = this.categories.map(el => ({
          code: el.classificationCode,
          title: el.title
        }))
        this.$emit('updateSubscribed')
      }
    },
    async addMember(new_members) {
      if (!new_members?.length) {
        return
      }
      let members = new_members?.concat(this.members)
        .map((member, memberIndex) => {
          return {
            ...member,
            uniqId: member.contactId + '_' + memberIndex
          }
        })

      let status = this.tender.tenderStatus?.id
      members = this.$_.groupBy(members, 'email')
      members = Object.values(members).map(array => array[1] || array[0])

      let limitRejected = false
      try {
        let rejected = [], warnings = []
        if ( this.tender.tenderStatus && (status == 4 || status == 7)) {
          await api.personalInvitation(new_members?.map(item =>  item.email ), this.tender.tenderId)
            .then(res => {
              if (res.errors.length) {
                limitRejected = isUnknownEmailsLimitRejection(res.errors)
                throw res.errors[0].message
              }
              rejected = res.rejected
              warnings = res.warnings
              // success=false with rejected addresses is reported per email below, not as a generic failure
              if ( !res.result?.success && !rejected.length ) {
                this.$notice.warning({
                  title: this.$t('Common.ErrorTitle'),
                  message: res.result?.messages,
                  showClose: true,
                  progress: true,
                  duration: 20
                })
                throw res.result?.messages
              }
            })
        } else if (this.tender.tenderStatus && status == 1) {
          await api.addInvitedParticipant({
            tenderId: this.tender.tenderId,
            invitedUsers: members?.map(item => ({
              email: item.email,
              contactId: item.contactId,
              organizationId: item.organizationId,
              manualAdded: !!item.manualAdded
            }))
          }).then(res => {
            if (res.errors.length) {
              limitRejected = isUnknownEmailsLimitRejection(res.errors)
              throw res.errors[0].message
            }
            rejected = res.rejected
            warnings = res.warnings
          })
        }
        // відхилені адреси так і не досягли бази даних, тому їх не додають до списку учасників
        members = members.filter(member => withoutRejected([member.email], rejected).length)
        this.all_members = members
        this.$emit( 'setMembersGroups')
        this.$_notifyEmailRejections(rejected, warnings)
      } catch (error ) {
        this.$log_error(error)
      }
      return limitRejected ? { limitRejected } : undefined
    },
  },
  components: {
    Youcontrol,
    SearchInput,
    TooltipedBtn,
    ExportToExcel,
    ResendInvitations,
    CategoryDropdownTree,
    InviteNewParticipation
  }
}
</script>
